import leadsAPI from "@/api/dailyleads";
import productsAPI from "@/api/products";
import moment from 'moment';

const state = () => ({
  options: {
    filters: { 
      kind: [],
      voidLead: false,
    }
  },
  dailyConfig: {
    paginationCount: 0,
    paginationLimit: 50,
    paginationPage: 1,
    kind: [],
    voidLead: false,
    date: '',
  },
  dailyLeads: [],
  dailyLeadsLoading: true,
  dailyLeadsError: [],
  voidReasons: [],
  lostReasons: [],
  newLead: {},
  newLeadLoading: false,

  addVoidReasonLoading: false,
  addVoidReasonError: false,
  addVoidReasonErrorResponse: null,

  voidDailyLeadLoading: false,
  voidDailyLeadError: false,
  voidDailyLeadErrorResponse: null 
});

const mutations = {
  SET_NEWLEAD(state, payload) { state.newLead = payload; },
  SET_NEWLEAD_LOADING(state, payload) { state.newLeadLoading = payload; },
  UPDATE_DAILY_PAGINATION(state, payload) {
    state.dailyConfig.paginationLimit = (payload.itemsPerPage!==undefined)?payload.itemsPerPage:state.dailyConfig.paginationLimit;
    state.dailyConfig.paginationPage = (payload.page)?payload.page:state.dailyConfig.paginationPage;
    state.dailyConfig.kind = (payload.kind!==undefined)?payload.kind:state.dailyConfig.kind;
    state.dailyConfig.voidLead = (payload.voidLead!==undefined)?payload.voidLead:state.dailyConfig.voidLead;
    state.dailyConfig.date = (payload.date!==undefined)?payload.date:state.dailyConfig.date;
    if(state.dailyConfig.date===""){
      state.dailyConfig.date = moment(new Date()).format('YYYY/MM/DD');
    }
  },
  SET_DAILY_LEADS(state, payload) {
    state.dailyLeads = payload.data;
    state.dailyConfig.paginationCount = parseInt(payload.headers['pagination-count']);
    state.dailyConfig.paginationLimit = parseInt(payload.headers['pagination-limit']);
    state.dailyConfig.paginationPage = parseInt(payload.headers['pagination-page']);
    state.dailyLeadsLoading = false;
  },
  SET_DAILY_LEADS_LOADING(state) {
    state.dailyLeadsLoading = true;
  },
  SET_DAILY_LEADS_ERROR(state, payload) {
    state.dailyLeadsLoading = false;
    state.dailyLeadsError = payload;
  },
  SET_FILTER_DAILY_LEADS(state, payload) {
    state.dailyLeadsLoading = false;
    state.options.filters.kind = payload.kind;
    state.options.filters.voidLead = payload.voidLead;
    state.dailyConfig.paginationPage = payload.page ? payload.page : state.dailyConfig.paginationPage;
  },
  SET_VOID_REASONS(state, payload) { state.voidReasons = payload; },
  SET_LOST_REASONS(state, payload) { state.lostReasons = payload; },

  ADD_VOID_REASON_BEGIN(state) {
    state.addVoidReasonLoading = true;
    state.addVoidReasonError = false;
    state.addVoidReasonErrorResponse = null;
  },
  ADD_VOID_REASON_SUCCESS(state) {
    state.addVoidReasonLoading = false;
  },
  ADD_VOID_REASON_ERROR(state, err) {
    state.addVoidReasonLoading = false;
    state.addVoidReasonError = true;
    state.addVoidReasonErrorResponse = err;
  },

  VOID_DAILY_LEAD_BEGIN(state) {
    state.voidDailyLeadLoading = true;
    state.voidDailyLeadError = false;
    state.voidDailyLeadErrorResponse = null;
  },
  VOID_DAILY_LEAD_SUCCESS(state) {
    state.voidDailyLeadLoading = false;
  },
  VOID_DAILY_LEAD_ERROR(state, err) {
    state.voidDailyLeadLoading = false;
    state.voidDailyLeadError = true;
    state.voidDailyLeadErrorResponse = err;
  }
};

const actions = {
  async updateDailyPagination({ commit, dispatch }, payload) {
    await commit("UPDATE_DAILY_PAGINATION", payload);
    dispatch("loadDailyLeads");
  },

  async addVoidReason({ commit }, payload) {
    commit('ADD_VOID_REASON_BEGIN');
    try {
      await leadsAPI.addVoidReason(payload);
      commit('ADD_VOID_REASON_SUCCESS');
    } catch (err) {
      commit('ADD_VOID_REASON_ERROR', err);
      throw err;
    }
  },

  async addLostReason({ dispatch }, payload) {
    try {
      await leadsAPI.addLostReason(payload);
    } catch (err) {
      throw err;
    }
  },

  async loadDailyLeads({ state,commit }) {
    try {
      commit("SET_DAILY_LEADS_LOADING");
      let data = await leadsAPI.loadDailyLeads(state.dailyConfig);
      data.data = Array.isArray(data.data) ? data.data : [];
      commit("SET_DAILY_LEADS", data);
    } catch(err) {
      commit("SET_DAILY_LEADS_ERROR", err);
    }
  },
  
  async createNewLead({ commit,dispatch },data) {
    commit("SET_NEWLEAD_LOADING",true);
    try {
      let res = await leadsAPI.createNewLead(data);
      commit("SET_NEWLEAD_LOADING",false);
      if(res.status===200){
        commit("SET_NEWLEAD",res.data);
        dispatch('alerts/setAlert',{type:'success',message:'Lead created successfully!'},{root:true});
        return true;
      }else{
        dispatch('alerts/setAlert',{type:'error',message:'Something went wrong?!'},{root:true});
        return false;
      }
    } catch(err) {
      dispatch('alerts/setAlert',{type:'error',message:err.response.data.message},{root:true});
      commit("SET_NEWLEAD_LOADING",false);
      return false;
    }
  },

  async assignSalesPerson({ dispatch }, payload) {
    try {
      dispatch("alerts/setAlert", {
        type: "info",
        message: `Updating lead`,
      }, { root: true });

      await leadsAPI.assignSalesPerson(payload);
      await dispatch("loadDailyLeads");

      dispatch("alerts/setAlert", {
        type: "success",
        message: `Lead updated successfully`,
      }, { root: true });

    } catch (err) {
      dispatch("alerts/setAlert", {
        type: "error",
        message: `There has been an error: ${err}`,
      }, { root: true });
    }
  },

  async voidDailyLead({ commit, dispatch }, payload) {
    commit('VOID_DAILY_LEAD_BEGIN');
    try {
      dispatch("alerts/setAlert", {type: "info",message: `Voiding lead`,}, { root: true });

      await productsAPI.voidProduct(payload);
      await dispatch("loadDailyLeads");
      commit('VOID_DAILY_LEAD_SUCCESS');
      dispatch("alerts/setAlert", {type: "success",message: `Voided lead successfully`,}, { root: true });

    } catch(err) {
      commit('VOID_DAILY_LEAD_ERROR', err);
      dispatch("alerts/setAlert", {type: "error",message: `There has been an error: ${err}`,}, { root: true });
    }
  },

  async lostDailyLead({ dispatch }, payload) {
    try {
      dispatch("alerts/setAlert", {type: "info",message: `Updating`,}, { root: true });

      await productsAPI.lostProduct(payload);
      dispatch("alerts/setAlert", {type: "success",message: `Lost lead successfully`,}, { root: true });

    } catch(err) {
      dispatch("alerts/setAlert", {type: "error",message: `There has been an error: ${err}`,}, { root: true });
    }
  },

  async filterDailyLeads({ dispatch, commit }, payload) {
    const { date, kind, voidLead, page, paginationCount } = payload;
    await dispatch('updateDailyPagination', page);
    if(date) {
      await dispatch('loadDailyLeads', date);
    }
    commit("SET_FILTER_DAILY_LEADS", { kind, voidLead });
  } ,

  async getVoidReasons({ dispatch, commit }) {
    try {
      let res = await leadsAPI.getVoidReasons();
      if(res.status===200){
        await commit("SET_VOID_REASONS", res.data);
      }
    } catch (err) {
      dispatch("alerts/setAlert", {type: "error",message: `There has been an error: ${err}`,}, { root: true });
    }
  },

  async getLostReasons({ dispatch, commit }) {
    try {
      let res = await leadsAPI.getLostReasons();
      if(res.status===200){
        await commit("SET_LOST_REASONS", res.data);
      }
    } catch (err) {
      dispatch("alerts/setAlert", {type: "error",message: `There has been an error: ${err}`,}, { root: true });
    }
  },
};

const getters = {
  getVoidReasonsArr: (state) => (type) => {
    return state.voidReasons.filter(e=>{
      if(e.kind===null){
        return e;
      }else if([type.toLowerCase()].indexOf(e.kind.toLowerCase())!==-1){
        return e;
      }
    }).map((e)=>{
      return {
        text: e.value,
        value: e.id,
      };
    });
  },
  getLostReasonsArr: (state) => (type) => {
    return state.lostReasons.filter(e=>{
      if(e.kind===null){
        return e;
      }else if([type.toLowerCase()].indexOf(e.kind.toLowerCase())!==-1){
        return e;
      }
    }).map((e)=>{
      return {
        text: e.value,
        value: e.id,
      };
    });
  },
  getDailyConfigs: (state) => state.dailyConfig,
  getNewLeadId: (state) => state.newLead,
  getDailyLeads: state => state.dailyLeads.filter(e => {
    if(!state.dailyConfig.voidLead) {
      if(e.status.toLowerCase() !== 'void') {
        return e;
      }
      return;
    }
    return e;
  }).filter(e => {
    if(state.options.filters.kind.length > 0) {
      const filter = state.options.filters.kind.map(e => e.toLowerCase());
      if(filter.includes(e.kind.toLowerCase())) {
        return e;
      }
      return;
    }
    return e;
  }),
  getDailyLeadsLoading: state => state.dailyLeadsLoading,

  getAddVoidReasonLoading: state => state.addVoidReasonLoading,
  getAddVoidReasonError: state => state.addVoidReasonError,
  getAddVoidReasonErrorResponse: state => state.addVoidReasonErrorResponse,

  getVoidDailyLeadLoading: state => state.voidDailyLeadLoading,
  getVoidDailyLeadError: state => state.voidDailyLeadError,
  getVoidDailyLeadErrorResponse: state => state.voidDailyLeadErrorResponse
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
